/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminRoleSelector
 */
export interface OutputAdminRoleSelector {
    /**
     * 
     * @type {string}
     * @memberof OutputAdminRoleSelector
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminRoleSelector
     */
    role: string;
}

/**
 * Check if a given object implements the OutputAdminRoleSelector interface.
 */
export function instanceOfOutputAdminRoleSelector(value: object): boolean {
    if (!('description' in value)) return false;
    if (!('role' in value)) return false;
    return true;
}

export function OutputAdminRoleSelectorFromJSON(json: any): OutputAdminRoleSelector {
    return OutputAdminRoleSelectorFromJSONTyped(json, false);
}

export function OutputAdminRoleSelectorFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminRoleSelector {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'role': json['role'],
    };
}

export function OutputAdminRoleSelectorToJSON(value?: OutputAdminRoleSelector | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'role': value['role'],
    };
}

